'use strict';

angular.module('app.networkDetail', [])
	.controller('networkDetailCtrl', ['$scope', '$rootScope', '$http', '$modal', 'networkDetailService',
		function ($scope, $rootScope, $http, $modal, networkDetailService) {
			var definitions = angular.copy($rootScope.definitions);
		    $scope.preLoadData = function(){
		        $scope.id = $scope.index.id;
		        $scope.name = $scope.index.name;
		        $scope.contact = $scope.index.address;
		        $scope.phone = $scope.index.phone;
		        $scope.email = $scope.index.contact_email;
		        $scope.status = $scope.index.deletedFlag;
		        $scope.renderCountry();
		    }

		    $scope.searchCountries = function(event) {
		        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
		            for(var i = 0; i < $scope.countries.length; i++) {
		                if($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
		                    var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
		                    var item = checkbox.find('label')[i];
		                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
		                    break;
		                }
		            }
		        }
		    }

		    $scope.renderCountry = function() {
		    	$scope.countries = definitions.countries;
		        $scope.countries.forEach(function (val){
                    if($scope.index.country != null){
                        if(val.id == $scope.index.country.id){
                            val.ticked = true;
                            $scope.outputCountry = val;
                        }
                    }
                })
		    }

		    $scope.preLoadData();
		    
		    $scope.updateNetwork = function (id) {
		        $scope.selectedCountryId = "";
		        $scope.countries.forEach(function (val) {
		            if (val.ticked === true) {
		                $scope.selectedCountryId = val.id;
		            }    
		        });

		        var params = {
		            id: $scope.id,
		            name: $scope.name,
		            country: $scope.selectedCountryId,
		            address: $scope.contact,
		            phone: $scope.phone,
		            contact_email: $scope.email
		        }

		       	networkDetailService.updateNetwork(params, true)
		       		.then(function(response) {
		       			$scope.modalInstance.close(function () {
			                $log.info('Close Modal now');
			            })

			            location.reload('admin/networks');
		       		}, function(response) {
		       			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		       		})
		    }

		    $scope.deleteNetwork = function () {
		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/networkManagement/networkDetail/deleteNetwork/deleteNetwork.html?app_v=deployDate',
		            controller: 'deleteNetworkCtrl'		            
		        });
		        $scope.network_id = $scope.index.id;
		        $scope.modalInstance = modalInstance;
		    }

		    $scope.revertNetwork = function () {

		        var modalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/networkManagement/networkDetail/revertNetwork/revertNetwork.html?app_v=deployDate',
		            controller: 'revertNetworkCtrl'
		        });
		        $scope.network_id = $scope.index.id;
		        $scope.modalInstance = modalInstance;
		    }    
}])